import {Sprite, Text} from '@inlet/react-pixi'
import React from 'react';
import cangrejo_ske from '../../resource/cangrejo/cangrejo_ske.json';
import cangrejo_tex from '../../resource/cangrejo/cangrejo_tex.json';
import cangrejo_png from '../../resource/cangrejo/cangrejo_tex.png';
import dragonBones from '../../dragonBones';
import * as PIXI from "pixi.js";

class Cangrejo extends React.Component {

    state = {rotation: 0}

    componentDidMount() {
        this.props.app.ticker.add(this.tick)
    }

    componentWillUnmount() {
        this.props.app.ticker.remove(this.tick)
    }

    tick(delta) {

    }

    render() {
        const factory = dragonBones.PixiFactory.factory;
        factory.parseDragonBonesData(cangrejo_ske);
        factory.parseTextureAtlasData(cangrejo_tex, PIXI.Texture.fromImage(cangrejo_png));

        const armatureDisplay = factory.buildArmatureDisplay("Armature", "cangrejo");
        armatureDisplay.animation.play("timeline");
        armatureDisplay.x = this.props.x;
        armatureDisplay.y = this.props.y;
        armatureDisplay.scale.x = this.props.scale;
        armatureDisplay.debugDraw = false;
        armatureDisplay.scale.y = this.props.scale;
        armatureDisplay.animation.timeScale = .7;
        setTimeout(() => {
            this.props.app.stage.addChild(armatureDisplay);
        }, this.props.timeout);
        return null
    }
}

export default Cangrejo;



// WEBPACK FOOTER //
// ./src/components/characters/Cangrejo.js